
import React, { useEffect } from "react";
import releaseFeatures from "../../Assets/MaintenancePage_Features.png";
import "../ErrorAndMaintenance/ErrorAndMaintenance.css";
import logo from "../../Assets/jobslogo.svg";
const Maintenance = () => {
   useEffect(() => {
            localStorage.removeItem("cns")
            localStorage.removeItem("cip")
            localStorage.removeItem("cdp")
        }, [])
  return (
    <div className="error-outer">
      <div className="mainte-banner">
        <img src={logo} alt="img1" />
      </div>
      <div className="maintenance-main">
        {/* The "Coming Soon" heading is part of the graphic, so the alt text
            carries it. */}
        <img
          className="maintenance-features"
          src={releaseFeatures}
          alt="Coming Soon: JO Enterprise Chat (JO-GPT) 2.0 — 7 new capabilities and 3 enhancements"
        />
        <div className="our-website-note-two">
          {/* <span className="our-website-note">Important Notice:</span>{" "} */}
          <p className="our-website"><strong>We'll be right back!</strong></p>
        </div>
        <p className="our-website">
          JO Enterprise Chat is undergoing a scheduled upgrade as we prepare to release JO Enterprise Chat (JO-GPT) 2.0, which will be available on <strong>October 12</strong>. The portal will be temporarily offline and will resume normal operations on October 12. We apologize for any inconvenience this may cause, and we appreciate your patience during this maintenance period.
        </p>
        <p className="our-website-mid-row">
          {/* Keep an eye on your email inbox on Monday, where we'll share a detailed overview of all the exciting enhancements and improvements. */}
        </p>
        <p className="our-website-last">
          For any questions or concerns, please contact the EDA team at: {""}
          <a href="mailto:Enterprise-Data-AI@jobsohio.com">
            Enterprise-Data-AI@jobsohio.com
          </a>
          .
        </p>
      </div>
    </div>
  );
};
export default Maintenance;



// import React from "react";
// import Layout from "../../Components/Layout/Layout";
// import maintenance from "../../Assets/maintenance.svg";
// import "../ErrorAndMaintenance/ErrorAndMaintenance.css";
// import logo from "../../Assets/jobsblack.svg";
// const Maintenance = () => {
//   return (
//     <div className="error-outer">
//       <div className="mainte-banner">
//         <img src={logo} alt="img1" />
//       </div>
//       <div className="maintenance-main">
//         <img src={maintenance} alt="" />
//         <div className="our-website-note-two">
//           <span className="our-website-note">Important Notice:</span>{" "}
//           <p className="our-website">As previously announced on Slack -</p>
//         </div>
//         <p className="our-website">
//           JOI will undergo essential weekend maintenance to enhance system
//           performance. The portal will be temporarily offline starting Friday,
//           February 14, at 5PM EST and will resume operations on Sunday, February
//           16th. This scheduled downtime is necessary to implement critical
//           updates and improvements to the JOI 2.0 portal, ensuring a more
//           efficient and reliable experience for all users. We understand this
//           may cause temporary inconvenience and sincerely appreciate your
//           patience during this maintenance period.
//         </p>
//         <p className="our-website-mid-row">
//           Keep an eye on your email inbox on Monday, February 17th, where we'll
//           share a detailed overview of all the exciting new enhancements and
//           improvements.
//         </p>
//         <p className="our-website-last">
//           For any questions, concerns, or additional information regarding this
//           scheduled maintenance, please contact the EDA team directly at: {""}
//           <a href="mailto:enterprisedata@jobsohio.com">
//             enterprisedata@jobsohio.com
//           </a>
//           .
//         </p>
//         {/* <p className='we-back'>We'll be right back!</p>
//         <p className='our-website'>Our website is currently undergoing scheduled maintenance to improve your experience.
//         </p>
//         <p className='thankyou-maintenance'>Thank you for your patience!</p> */}
//       </div>
//     </div>
//   );
// };
// export default Maintenance;